import React from 'react'
import {PageHeader} from '@/components/molecules'
import InventoryList from '@/features/InventoryList/InventoryListV2.jsx'
import {Fulfillment} from '@/containers/Fulfillment/Fulfillment.jsx'


export const InventoryListPage = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title={'Inventory'} />
      </div>
      <InventoryList />
    </div>
  )
}
export default InventoryListPage